import * as React from "react";
import { Heading } from "@grandvisionhq/elements";
/* empty css                                                         */
const UpsellLayout = (props) => /* @__PURE__ */ React.createElement("div", { className: "upsell-layout" }, /* @__PURE__ */ React.createElement(Heading, { className: "upsell-layout__header", variant: "smallest", component: "h2" }, props.heading), props.children);
export {
  UpsellLayout
};
//# sourceMappingURL=UpsellLayout.js.map
